import { Box } from 'foundations-components/transitional/components/Box';
import { Select } from 'foundations-components/transitional/components/Select';
import { useCallback } from 'react';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { useIsUngatedForCustomerAgentGlobalHandoffs, useIsUngatedForInboundCredits, useIsUngatedForTeamsOnly } from '../../auth/hooks/useGates';
import { getRoutingTypeOptions } from '../constants/RoutingRulesSelectOptions';
import { KEEP_ASSIGNEE, ROUTING_RULE_TYPES } from '../constants/RoutingTypes';
import NoAccessToInboxTooltip from './tooltips/NoAccessToInboxTooltip';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const SelectAssignmentGroup = ({
  aiChatbotId,
  currentGroup,
  disabled,
  disableKeepAssignee,
  menuWidth,
  onChange,
  onOpenChange,
  overrides,
  routingSource,
  showAnyUser,
  showKeepAssignee,
  showTeamsOnly,
  showUnassigned,
  showOwner
}) => {
  const {
    openUpgradeModal
  } = useUpgradeModal('livemessages-routing');
  const isUngatedForTeamsOnly = useIsUngatedForTeamsOnly();
  const isUngatedForInboundCredits = useIsUngatedForInboundCredits();
  const isUngatedForCustomerAgentGlobalHandoffs = useIsUngatedForCustomerAgentGlobalHandoffs();
  const shouldUseCustomerAgentRule = currentGroup !== ROUTING_RULE_TYPES.AI_CHATBOT && (isUngatedForCustomerAgentGlobalHandoffs || currentGroup === ROUTING_RULE_TYPES.CUSTOMER_AGENT);
  const defaultMenuWidth = isUngatedForTeamsOnly ? undefined : 250;
  const itemComponent = useCallback(itemComponentProps => {
    if (disableKeepAssignee && itemComponentProps.option.value === KEEP_ASSIGNEE) {
      return /*#__PURE__*/_jsx(NoAccessToInboxTooltip, {
        children: /*#__PURE__*/_jsx(_Fragment, {
          children: itemComponentProps.children
        })
      });
    }
    return /*#__PURE__*/_jsx(_Fragment, {
      children: itemComponentProps.children
    });
  }, [disableKeepAssignee]);
  return /*#__PURE__*/_jsx(Box, {
    basis: 240,
    grow: 0,
    children: /*#__PURE__*/_jsx(Select, {
      "data-test-id": "select-assignment-group",
      disabled: disabled,
      defaultOpen: false,
      itemComponent: itemComponent,
      options: getRoutingTypeOptions({
        disableKeepAssignee,
        isUngatedForTeamsOnly,
        isUngatedForInboundCredits,
        shouldUseCustomerAgentRule,
        overrides,
        showAnyUser,
        showKeepAssignee,
        showTeamsOnly,
        showUnassigned,
        showOwner,
        aiChatbotId,
        routingSource
      }),
      searchable: false,
      value: currentGroup,
      menuWidth: menuWidth !== null && menuWidth !== void 0 ? menuWidth : defaultMenuWidth,
      onChange: onChange,
      onOpenChange: onOpenChange,
      onSelectedOptionChange: e => {
        if (e.target.value.locked) {
          openUpgradeModal();
        }
      }
    })
  }, currentGroup);
};
SelectAssignmentGroup.displayName = 'SelectAssignmentGroup';
export default SelectAssignmentGroup;